import Mock from '../mock'
import jwt from 'jsonwebtoken'

import { initializeApp } from 'firebase/app';
import { firebaseConfig } from 'config'
import {
    getAuth,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    createUserWithEmailAndPassword,
    updateProfile
} from "firebase/auth";

initializeApp(firebaseConfig)

const JWT_SECRET = 'jwt_secret_key'
const JWT_VALIDITY = '7 days'

const userList = [
    {
        id: 1,
        role: 'SA',
        name: 'Jason Alexander',
        username: 'jason_alexander',
        email: 'jason@ui-lib.com',
        avatar: '/assets/images/face-6.jpg',
        age: 25,
    },
]

// FOLLOWING CODES ARE MOCK SERVER IMPLEMENTATION
// YOU NEED TO BUILD YOUR OWN SERVER
// IF YOU NEED HELP ABOUT SERVER SIDE IMPLEMENTATION
// CONTACT US AT support@ui-lib.com

Mock.onPost('/api/auth/login').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))

        const { email, password } = JSON.parse(config.data)

        const auth = getAuth();
        const response = signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;

                return user
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(error)

                // ..
            });

        const user = await response

        if (!user) {
            return [400, { message: 'Invalid email or password' }]
        }
        const accessToken = user.accessToken
        const role = JSON.parse(user.reloadUserInfo.customAttributes || "{\"role\":\"GUEST\"}") 

        return [
            200,
            {
                accessToken,
                role,
                user: user,
            },
        ]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/register').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))

        const { email, username, password } = JSON.parse(config.data)

        const auth = getAuth();
        const response = createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;

                return user
                // ...
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(error)

                // ..
            });

        const user = await response

        await updateProfile(user, { displayName: username })

        const accessToken = user.accessToken
        const role = JSON.parse(user.reloadUserInfo.customAttributes || "{\"role\":\"GUEST\"}")

        return [
            200,
            {
                accessToken,
                role,
                user: user,
            },
        ]

    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onGet('/api/auth/profile').reply(async (config) => {
    try {
        const auth = getAuth();
        let result = null
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                const uid = user.uid;
                const role = user.reloadUserInfo.customAttributes ? JSON.parse(user.reloadUserInfo.customAttributes) : 'GUEST'

                result = [
                    200,
                    {
                        user: user,
                        role
                    },
                ]
                // ...
            } else {
                // User is signed out
                result = [401, { message: 'Invalid authorization token' }]
                // ...
            }
        });

        await new Promise((resolve) => setTimeout(resolve, 1000))

        const { Authorization } = config.headers

        if (!Authorization) {
            return [401, { message: 'Invalid Authorization token' }]
        }

        const accessToken = Authorization.split(' ')[1]
        return result
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})
